<template>
  <div>
    <Movementmenu />

    <v-container fluid class="pa-6" tag="section">
      <v-row class="mb-2">
        <v-col cols="12">
          <h2 class="text-h4 font-weight-bold mb-2 primary--text">
            <v-icon large color="primary" class="mr-2"
              >mdi-file-document-edit-outline</v-icon
            >
            จัดการคำสั่งย้าย (Order of Appointment)
          </h2>
          <div class="subtitle-1 grey--text text--darken-1">
            ระบบบริหารจัดการคำสั่งแต่งตั้งและโยกย้ายข้าราชการครู
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #455A64"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">คำสั่งทั้งหมด</div>
                <div class="text-h4 font-weight-bold">{{ stats.total }}</div>
              </div>
              <v-avatar color="info lighten-5" size="60">
                <v-icon color="info" x-large>mdi-folder-multiple</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #2E7D32"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">ปีงบประมาณล่าสุด</div>
                <div class="text-h4 font-weight-bold success--text">
                  {{ stats.latestYear }}
                </div>
              </div>
              <v-avatar color="success lighten-5" size="60">
                <v-icon color="success" x-large>mdi-calendar-check</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #A86400"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รอบการย้ายล่าสุด</div>
                <div class="text-h4 font-weight-bold warning--text">
                  {{ stats.latestRound }}
                </div>
              </div>
              <v-avatar color="warning lighten-5" size="60">
                <v-icon color="warning" x-large
                  >mdi-clock-time-four-outline</v-icon
                >
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #B3151B"
          >
            <v-btn
              block
              color="primary"
              class="fill-height"
              rounded
              large
              @click="order_appointAdd()"
            >
              <v-icon left>mdi-plus-circle</v-icon> สร้างคำสั่งใหม่
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <v-card elevation="2" class="rounded-lg mb-4">
        <v-toolbar flat color="white" class="pt-2">
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหาเลขที่หนังสือ, คำสั่ง, หรือปี..."
                single-line
                hide-details
                outlined
                dense
                rounded
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
              <v-btn
                color="success"
                outlined
                block
                rounded
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> Export Excel
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </v-card>

      <v-card elevation="2" class="rounded-lg">
        <v-data-table
          :headers="headers"
          :items="order_appoints"
          :search="search"
          :loading="loading"
          :items-per-page="10"
          class="elevation-0"
        >
          <template v-slot:item.dated_order="{ item }">
            <div class="d-flex align-center">
              <v-icon small class="mr-1" color="grey">mdi-calendar</v-icon>
              {{ formatDateThai(item.dated_order) }}
            </div>
          </template>

          <template v-slot:item.start_date="{ item }">
            <span class="font-weight-bold primary--text">{{
              formatDateThai(item.start_date)
            }}</span>
          </template>

          <template v-slot:item.time_year="{ item }">
            <v-chip
              color="primary lighten-5"
              text-color="primary darken-2"
              small
              label
            >
              <strong>{{ item.time_s }} / {{ item.year_s }}</strong>
            </v-chip>
          </template>

          <template v-slot:item.reports="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="info"
                  dark
                  small
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  rounded
                >
                  <v-icon left small>mdi-printer</v-icon> พิมพ์รายงาน
                  <v-icon right small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  link
                  :href="'#/admin/print_report_manpower'"
                  target="_blank"
                >
                  <v-list-item-icon
                    ><v-icon color="info"
                      >mdi-account-group</v-icon
                    ></v-list-item-icon
                  >
                  <v-list-item-title>ตำแหน่งว่าง</v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                  :href="getReportLink(item, 'print_report_movement_online_4')"
                  target="_blank"
                >
                  <v-list-item-icon
                    ><v-icon color="warning"
                      >mdi-file-document-alert</v-icon
                    ></v-list-item-icon
                  >
                  <v-list-item-title>การย้ายคงค้าง</v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                  :href="getReportLink(item, 'print_report_movement_filter_3')"
                  target="_blank"
                >
                  <v-list-item-icon
                    ><v-icon color="error"
                      >mdi-filter-check</v-icon
                    ></v-list-item-icon
                  >
                  <v-list-item-title>กลั่นกรองเสนอ</v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                  to="/admin/report_movement_filter"
                ><!-- :href="getReportLink(item, 'print_report_movement_filter_o')"
                  target="_blank" -->
                  <v-list-item-icon
                    ><v-icon color="warning darken-3"
                      >mdi-gavel</v-icon
                    ></v-list-item-icon
                  >
                  <v-list-item-title>อ.ก.ค.ศ.</v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                  :href="getReportLink(item, 'print_report_movement')"
                  target="_blank"
                >
                  <v-list-item-icon
                    ><v-icon color="success"
                      >mdi-file-sign</v-icon
                    ></v-list-item-icon
                  >
                  <v-list-item-title>คำสั่งย้าย</v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                  :href="
                    getReportLink(item, 'print_report_movement_filter_salary')
                  "
                  target="_blank"
                >
                  <v-list-item-icon
                    ><v-icon color="info"
                      >mdi-cash-multiple</v-icon
                    ></v-list-item-icon
                  >
                  <v-list-item-title>ตารางเงินเดือน</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <template v-slot:item.approve_movement="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="success"
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="approve_movement_dialog(item.id_oa)"
                >
                  <v-icon>mdi-account-check</v-icon>
                </v-btn>
              </template>
              <span>อนุมัติการย้าย</span>
            </v-tooltip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              color="warning"
              @click.stop="order_appointEdit(item.id_oa)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              icon
              color="error"
              @click.stop="order_appointDelete(item.id_oa)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="loading_dialog" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            กรุณารอสักครู่...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="addorder_appointdialog" persistent max-width="800px">
        <v-card class="rounded-xl">
          <v-toolbar :color="isEditMode ? 'warning' : 'primary'" dark flat>
            <v-icon class="mr-2">{{
              isEditMode ? "mdi-pencil" : "mdi-plus-circle"
            }}</v-icon>
            {{ isEditMode ? "แก้ไขข้อมูลคำสั่งย้าย" : "เพิ่มข้อมูลคำสั่งย้าย" }}
            <v-spacer></v-spacer>
            <v-btn icon @click="closeOrderDialog"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-6">
            <v-form ref="orderForm" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="หนังสือราชการที่"
                    v-model="formOrder.book_number"
                    outlined
                    dense
                    prepend-inner-icon="mdi-book"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="คำสั่งที่"
                    v-model="formOrder.order_number"
                    outlined
                    dense
                    prepend-inner-icon="mdi-file-document"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="menu_date_order"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formOrder.dated_order"
                        label="วันที่หนังสือ"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formOrder.dated_order"
                      locale="th"
                      @input="menu_date_order = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="menu_start_date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formOrder.start_date"
                        label="วันที่เริ่มปฏิบัติงาน"
                        prepend-inner-icon="mdi-calendar-check"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :rules="[v => !!v || 'จำเป็น']"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formOrder.start_date"
                      locale="th"
                      @input="menu_start_date = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    label="ประชุมครั้งที่"
                    v-model="formOrder.meeting_no"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="menu_meeting_date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formOrder.meeting_date"
                        label="วันที่ประชุม"
                        prepend-inner-icon="mdi-calendar-clock"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formOrder.meeting_date"
                      locale="th"
                      @input="menu_meeting_date = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select
                    label="ครั้งที่"
                    v-model="formOrder.time_s"
                    :items="time_ss"
                    outlined
                    dense
                    :rules="[v => !!v || 'จำเป็น']"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    label="ปีงบประมาณ"
                    v-model="formOrder.year_s"
                    :items="year_ss"
                    outlined
                    dense
                    :rules="[v => !!v || 'จำเป็น']"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    label="ตำแหน่ง"
                    v-model="formOrder.name_position"
                    :items="name_position_s"
                    item-value="value"
                    outlined
                    dense
                    :rules="[v => !!v || 'จำเป็น']"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="grey lighten-5 pa-4">
            <v-spacer></v-spacer>
            <v-btn text @click="closeOrderDialog">ยกเลิก</v-btn>
            <v-btn color="success" elevation="2" @click="saveOrderSubmit">
              <v-icon left>mdi-content-save</v-icon> บันทึกข้อมูล
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteorder_appointdialog" persistent max-width="500">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text"
            >ยืนยันการลบข้อมูล</v-card-title
          >
          <v-card-text>
            คุณต้องการลบคำสั่งหนังสือเลขที่:
            <b>{{ editorder_appoint.book_number }}</b
            ><br />
            คำสั่งที่: <b>{{ editorder_appoint.order_number }}</b> ใช่หรือไม่?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteorder_appointdialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn color="error" dark @click="deleteorder_appointSubmit"
              >ยืนยันลบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="approve_movement_dialogs" persistent max-width="95%">
        <v-card class="rounded-xl">
          <v-toolbar color="info darken-1" dark flat>
            <v-icon class="mr-2">mdi-account-check</v-icon>
            อนุมัติการย้ายข้าราชการครู
            <v-spacer></v-spacer>
            <v-btn icon @click="approve_movement_dialogs = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-4">
            <v-row>
              <v-col cols="12">
                <div class="d-flex align-center flex-wrap">
                  <v-chip class="mr-2 mb-2" color="primary" outlined
                    >หนังสือ: {{ editorder_appoint.book_number }}</v-chip
                  >
                  <v-chip class="mr-2 mb-2" color="primary" outlined
                    >คำสั่ง: {{ editorder_appoint.order_number }}</v-chip
                  >
                  <v-chip class="mr-2 mb-2" color="success" outlined
                    >วันเริ่มงาน:
                    {{ formatDateThai(editorder_appoint.start_date) }}</v-chip
                  >
                </div>
              </v-col>
            </v-row>

            <v-card outlined>
              <v-card-title>
                <v-text-field
                  v-model="search_condition"
                  append-icon="mdi-magnify"
                  label="ค้นหาในรายการ..."
                  single-line
                  hide-details
                  dense
                  outlined
                  rounded
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="header_condition"
                :items="conditons_transfer_successs"
                :search="search_condition"
                :loading="loading"
              >
                <template v-slot:item.college_name_old="{ item }">
                  <span class="grey--text">{{ item.college_name_old }}</span>
                </template>
                <template v-slot:item.college_name_new="{ item }">
                  <span class="success--text font-weight-bold">{{
                    item.college_name_new
                  }}</span>
                </template>
                <template v-slot:item.approve_movements="{ item }">
                  <v-chip
                    v-if="item.id_position_check === item.id_position"
                    color="success"
                    small
                  >
                    <v-icon left small>mdi-check-circle</v-icon> สำเร็จ
                  </v-chip>
                  <v-btn
                    v-else
                    small
                    color="primary"
                    depressed
                    rounded
                    @click.stop="approve_movement_personnel(item.id_cts)"
                  >
                    <v-icon left small>mdi-gavel</v-icon> อนุมัติ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
          <v-card-actions class="grey lighten-5 pa-4">
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              large
              elevation="2"
              @click="approve_movement_dialogs_allSubmit"
            >
              <v-icon left>mdi-check-all</v-icon> อนุมัติย้ายทั้งหมด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="conditons_transfer_successs_personnel_dialog"
        max-width="700"
      >
        <v-card>
          <v-toolbar color="success" dark dense flat
            >ยืนยันการอนุมัติรายบุคคล</v-toolbar
          >
          <v-card-text class="pa-4">
            <v-simple-table>
              <tbody>
                <tr>
                  <td class="font-weight-bold">ชื่อ-สกุล</td>
                  <td>
                    {{ conditons_transfer_successs_personnel.title_s
                    }}{{ conditons_transfer_successs_personnel.frist_name }}
                    {{ conditons_transfer_successs_personnel.last_name }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">จาก</td>
                  <td>
                    {{
                      conditons_transfer_successs_personnel.college_name_old
                    }}
                    (เลขที่:
                    {{ conditons_transfer_successs_personnel.id_postion_old }})
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">ไปที่</td>
                  <td class="success--text">
                    {{
                      conditons_transfer_successs_personnel.college_name_new
                    }}
                    (เลขที่:
                    {{ conditons_transfer_successs_personnel.id_position }})
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="conditons_transfer_successs_personnel_dialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="success"
              @click="conditons_transfer_successs_personnel_dialogSubmit"
              >ยืนยันอนุมัติ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">{{ snackbar.icon }}</v-icon> {{ snackbar.text }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // npm install xlsx
import { saveAs } from "file-saver"; // npm install file-saver
import moment from "moment"; // Assuming moment is available based on original code

export default {
  name: "OrderAppoint",
  components: { Movementmenu },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      loading_dialog: false,
      search: "",

      // Data Holders
      order_appoints: [],

      // Dialog Controls & Forms
      addorder_appointdialog: false,
      isEditMode: false,
      formOrder: {}, // Combined form for Add/Edit

      deleteorder_appointdialog: false,
      editorder_appoint: {}, // Used for Delete/Approve context

      approve_movement_dialogs: false,
      search_condition: "",
      conditons_transfer_successs: [], // List inside approve dialog

      conditons_transfer_successs_personnel_dialog: false,
      conditons_transfer_successs_personnel: {}, // Single person data

      // Date Pickers
      menu_date_order: false,
      menu_start_date: false,
      menu_meeting_date: false,

      // Options
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],
      name_position_s: [
        { text: "สายการสอนและสนับสนุนการสอน", value: "ครู" },
        { text: "สายงานบริหารสถานศึกษา", value: "บริหาร" }
      ],

      // Table Headers
      headers: [
        { text: "หนังสือราชการที่", value: "book_number", align: "start" },
        { text: "คำสั่งที่", value: "order_number", align: "start" },
        { text: "วันที่หนังสือ", value: "dated_order" },
        { text: "รอบ/ปี", value: "time_year", align: "center" },
        { text: "เริ่มปฏิบัติงาน", value: "start_date" },
        { text: "ตำแหน่ง", value: "name_position" },
        { text: "รายงาน", value: "reports", align: "center", sortable: false },
        {
          text: "อนุมัติ",
          value: "approve_movement",
          align: "center",
          sortable: false
        },
        { text: "จัดการ", value: "actions", align: "center", sortable: false }
      ],
      header_condition: [
        { text: "ครั้งที่/ปี", value: "ctstime_s" },
        { text: "ชื่อ-สกุล", value: "title_s" },
        { text: "สังกัดเดิม", value: "college_name_old" },
        { text: "สังกัดใหม่", value: "college_name_new" },
        { text: "ตำแหน่งใหม่", value: "ctsname_position" },
        { text: "เลขที่", value: "ctsid_position" },
        { text: "สถานะ", value: "approve_movements", align: "center" }
      ],

      snackbar: { show: false, color: "", timeout: 4000, icon: "", text: "" }
    };
  },
  computed: {
    stats() {
      if (!this.order_appoints.length)
        return { total: 0, latestYear: "-", latestRound: "-" };
      const total = this.order_appoints.length;
      const latestYear = Math.max(
        ...this.order_appoints.map(i => parseInt(i.year_s) || 0)
      );
      const latestRound = this.order_appoints[0].time_s || "-";
      return { total, latestYear, latestRound };
    },
    date_today() {
      // Helper for form default
      return new Date().toISOString().substr(0, 10);
    }
  },
  async mounted() {
    await this.order_appointQueryAll();
  },
  methods: {
    // --- Utils ---
    formatDateThai(date) {
      if (!date) return "";
      return moment(date)
        .add(543, "years")
        .format("D MMMM YYYY");
    },
    showSnackbar(type, text) {
      this.snackbar.color = type === "success" ? "success" : "red accent-2";
      this.snackbar.icon =
        type === "success" ? "mdi-check-circle" : "mdi-alert-circle";
      this.snackbar.text = text;
      this.snackbar.show = true;
    },
    getReportLink(item, reportName) {
      // Construct link based on pattern in original code
      return `#/admin/${reportName}/${item.id_oa}/${item.time_s}/${item.year_s}/teach`;
    },

    // --- API Calls ---
    async order_appointQueryAll() {
      this.loading = true;
      try {
        let result = await this.$http.post("order_appoint.php", {
          ApiKey: this.ApiKey
        });
        this.order_appoints = result.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    // --- Add / Edit Logic ---
    order_appointAdd() {
      this.isEditMode = false;
      this.formOrder = {
        dated_order: this.date_today,
        start_date: this.date_today,
        meeting_date: this.date_today,
        book_number: "",
        order_number: "",
        meeting_no: "",
        time_s: "",
        year_s: "",
        name_position: "ครู"
      };
      this.addorder_appointdialog = true;
    },
    async order_appointEdit(id_oa) {
      this.loading_dialog = true;
      try {
        let result = await this.$http.post("order_appoint.php", {
          ApiKey: this.ApiKey,
          id_oa: id_oa
        });
        this.formOrder = { ...result.data };
        this.isEditMode = true;
        this.addorder_appointdialog = true;
      } finally {
        this.loading_dialog = false;
      }
    },
    closeOrderDialog() {
      this.addorder_appointdialog = false;
      this.$refs.orderForm.resetValidation();
    },
    async saveOrderSubmit() {
      if (!this.$refs.orderForm.validate()) return;

      this.formOrder.ApiKey = this.ApiKey;
      const endpoint = this.isEditMode
        ? "order_appoint.update.php"
        : "order_appoint.insert.php";

      try {
        if (!this.isEditMode)
          this.formOrder.date_time = moment().format("DD/MM/YYYY");

        let result = await this.$http.post(endpoint, this.formOrder);
        if (result.data.status) {
          this.showSnackbar("success", "บันทึกข้อมูลสำเร็จ");
          this.closeOrderDialog();
          this.order_appointQueryAll();
        } else {
          this.showSnackbar("error", "บันทึกข้อมูลล้มเหลว");
        }
      } catch (e) {
        this.showSnackbar("error", "เกิดข้อผิดพลาดในการเชื่อมต่อ");
      }
    },

    // --- Delete Logic ---
    async order_appointDelete(id_oa) {
      let result = await this.$http.post("order_appoint.php", {
        ApiKey: this.ApiKey,
        id_oa: id_oa
      });
      this.editorder_appoint = result.data;
      this.deleteorder_appointdialog = true;
    },
    async deleteorder_appointSubmit() {
      this.editorder_appoint.ApiKey = this.ApiKey;
      let result = await this.$http.post(
        "order_appoint.delete.php",
        this.editorder_appoint
      );
      if (result.data.status) {
        this.showSnackbar("success", "ลบข้อมูลเรียบร้อย");
        this.order_appointQueryAll();
      } else {
        this.showSnackbar("error", "ลบข้อมูลล้มเหลว");
      }
      this.deleteorder_appointdialog = false;
    },

    // --- Approve Logic ---
    async approve_movement_dialog(id_oa) {
      this.loading_dialog = true;
      try {
        // Get Order Info
        let res_oa = await this.$http.post("order_appoint.php", {
          ApiKey: this.ApiKey,
          id_oa: id_oa
        });
        this.editorder_appoint = res_oa.data;

        // Get Candidates List
        let res_list = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          transfer_approve: "ok"
        });
        this.conditons_transfer_successs = res_list.data;

        this.approve_movement_dialogs = true;
      } finally {
        this.loading_dialog = false;
      }
    },
    async approve_movement_personnel(id_cts) {
      let result = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        id_cts: id_cts
      });
      this.conditons_transfer_successs_personnel = result.data;
      this.conditons_transfer_successs_personnel_dialog = true;
    },
    async conditons_transfer_successs_personnel_dialogSubmit() {
      const payload = {
        ApiKey: this.ApiKey,
        college_code: this.conditons_transfer_successs_personnel.college_code,
        id_card: this.conditons_transfer_successs_personnel.id_card,
        id_position: this.conditons_transfer_successs_personnel.id_position,
        order_app_now: this.editorder_appoint.order_number,
        date_app_now: this.editorder_appoint.start_date
      };

      let result = await this.$http.post(
        "transference_approve.update.php",
        payload
      );
      if (result.data.status) {
        this.showSnackbar("success", "อนุมัติเรียบร้อย");
        this.conditons_transfer_successs_personnel_dialog = false;
        // Refresh list inside dialog
        let res_list = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          transfer_approve: "ok"
        });
        this.conditons_transfer_successs = res_list.data;
      } else {
        this.showSnackbar("error", "เกิดข้อผิดพลาด");
      }
    },
    async approve_movement_dialogs_allSubmit() {
      // Batch Approve Logic
      const payload = {
        ApiKey: this.ApiKey,
        time_s: this.editorder_appoint.time_s,
        year_s: this.editorder_appoint.year_s,
        name_position: "ครู"
      };

      this.loading_dialog = true;
      try {
       let result = await this.$http.post("transference_approve_all.update.php", payload);
       let resultJ18 = await this.$http.post("transference_approve_all.updateJ18.php");
        console.log(result.data, resultJ18.data);
        // Refresh
        let res_list = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          transfer_approve: "ok"
        });
        this.conditons_transfer_successs = res_list.data;

        this.showSnackbar("success", "อนุมัติทั้งหมดเรียบร้อย");
      } catch (e) {
        this.showSnackbar("error", "เกิดข้อผิดพลาดในการอนุมัติหมู่");
      } finally {
        this.loading_dialog = false;
      }
    },

    // --- Excel Export ---
    exportToExcel() {
      const exportData = this.order_appoints.map(item => ({
        หนังสือราชการที่: item.book_number,
        คำสั่งที่: item.order_number,
        วันที่หนังสือ: this.formatDateThai(item.dated_order),
        ประชุมครั้งที่: item.meeting_no,
        วันที่ประชุม: this.formatDateThai(item.meeting_date),
        ครั้งที่: item.time_s,
        ปีงบประมาณ: item.year_s,
        เริ่มปฏิบัติงาน: this.formatDateThai(item.start_date),
        ตำแหน่ง: item.name_position
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Order_Appoints");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      });
      saveAs(
        data,
        `Order_Appoint_${new Date().toISOString().slice(0, 10)}.xlsx`
      );
    }
  }
};
</script>

<style scoped>
/* Custom Style to ensure menu links don't have underline */
a {
  text-decoration: none;
}
</style>
